import { useCallback, useContext, useEffect } from "react";
import { Tabs } from "@hdi-seguros/web-components.tabs";

import { StepThreeFormContext } from "../../contexts";

import { GenericDataFormContext, QUOTATION_BUTTON, QuotationInfoContext, QuotationStep, QuotationStepButtons } from "../../../../../shared";

import { Form } from "../../../../../../../../../shared/components";

import { Summary } from "../Summary";
import { TheftInsurancePaymentMethods } from "../PaymentMethods";
import { generateInputID, getCoverageAndActivityKeyByID } from "../../../../../AP/Steps/StepThree/components/Quotation/utils";

export const TheftInsuranceQuotation = () => {
  const { 
    activeTab,
    clearPrimaFieldsOnFormChange,
    createTabs,
    handlerOnClick,
    labelButton,
    quotationResponse,
    quotationTabs,
    setActiveTab,
    setLabelButton,
    stepThreeTheftInsuranceQuotationForm,
  } = useContext(StepThreeFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext);

  useEffect(() => {
    setActiveTab(1);
    createTabs();
  }, [createTabs]);
  
  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    setFormValues(stepThreeTheftInsuranceQuotationForm.getFieldsValue());
    if( quotationResponse ) setLabelButton( QUOTATION_BUTTON.RECOTIZAR );
    setCurrentStep( QuotationStep.TWO )
  }, [
    setCurrentStep, 
    quotationResponse, 
    setLabelButton,
    setFormValues,
    stepThreeTheftInsuranceQuotationForm,
  ]);

  const onChangeForm = useCallback(( changedFields: any[] ) => {
    if( quotationResponse ) {
      setLabelButton( QUOTATION_BUTTON.RECOTIZAR );
      clearPrimaFieldsOnFormChange()
    };
    
    const nameOfFieldChanged: string = changedFields[0].name[0];
    const valueChanged = changedFields[0].value;

    const { activityKey, id } = getCoverageAndActivityKeyByID( nameOfFieldChanged );

    const tabKey = activityKey.split('-')[2];

    const planSelected = stepThreeTheftInsuranceQuotationForm.getFieldValue(`plan-tab-${tabKey}`);
    
    const allCoveragesByTab = allCoveragesPerPlan.find( el => (el.plan as string) === String(planSelected) )?.coverages;

    //* Verifico si la cobertura que modifique es alguna de las que dependen otras..
    const coverageCode = allCoveragesByTab?.find( el => el.id === id )?.codigo;

    if( coverageCode ) {
      //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relacion con este coverageCode.
      const relatedCoverages = allCoveragesByTab?.filter( el => el.codigoCoberturaRelacionada === coverageCode );

      //* Ahora tendria que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
      relatedCoverages.forEach(({ id, porcentajeSumaAsegegurada }) => {
        const checkboxName = generateInputID( id, activityKey, 'checkbox' );
        if( stepThreeTheftInsuranceQuotationForm.getFieldValue( checkboxName ) ) {
          const inputName = generateInputID( id, activityKey );
          stepThreeTheftInsuranceQuotationForm.setFieldValue( inputName, Math.round( valueChanged * ( Number( porcentajeSumaAsegegurada ) / 100 ) ));
        }
      })
    }
  }, [ 
    setLabelButton, 
    allCoveragesPerPlan, 
    stepThreeTheftInsuranceQuotationForm, 
    quotationResponse, 
    clearPrimaFieldsOnFormChange, 
  ]);

  return (
    <div>
      <Form 
        formProps={{ 
          form: stepThreeTheftInsuranceQuotationForm, 
          name: 'quotation-theft-insurance-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs 
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      { 
        quotationResponse 
          ? (
            <> 
              <TheftInsurancePaymentMethods />

              <Summary />

            </>
          ) 
          : <></> 
      }
  
      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </div>
  );
};